module.exports = __webpack_public_path__ + "img/marketing_map_1.56c3e269.png";